import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { sendBalanceEnquiry } from "../../redux/InwardIteraction/actions";
import InwardXml from "../Nip/InwardInteraction";

const BalanceEnquiry = (props) => {
  const {
    goToFundTransferDirectCredit,
    goToMandateAdvice,
    sendType,
    balanceEnquiry,
    isLoading,
  } = props;

  const handleBalanceEnquiry1 = () => {
    const payload = {
      type: "valid_auth",
    };
    sendType(payload);
  };

  const handleBalanceEnquiry2 = () => {
    const payload = {
      type: "invalid_auth",
    };
    sendType(payload);
  };

  const request = balanceEnquiry && balanceEnquiry.request;
  const response = balanceEnquiry && balanceEnquiry.response;

  return (
    <InwardXml
      prev={goToMandateAdvice}
      next={goToFundTransferDirectCredit}
      title={"Balance Enquiry (BE)"}
      request={request}
      response={response}
      optiontitle1={"Send BE using any valid authorization code"}
      optiontitle2={
        "Send BE using an invalid or non exixting authorization code"
      }
      handleCase1={handleBalanceEnquiry1}
      handleCase2={handleBalanceEnquiry2}
      isLoading={isLoading}
    />
  );
};

BalanceEnquiry.propTypes = {
  balanceEnquiry: PropTypes.shape({
    request: PropTypes.any,
    response: PropTypes.any,
  }),
  goToFundTransferDirectCredit: PropTypes.any,
  goToMandateAdvice: PropTypes.any,
  isLoading: PropTypes.any,
  sendType: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    isLoading: state.inwardInteraction.isLoading,
    sendBalanceEnquirySuccess:
      state.inwardInteraction.sendBalanceEnquirySuccess,
    balanceEnquiry: state.inwardInteraction.sendBalanceEnquiry,
  };
};

const mapDispatchToProps = (dispatch) => ({
  sendType: (payload) => dispatch(sendBalanceEnquiry(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BalanceEnquiry);
